"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraversalSolvableCharacteristicMatcherSchema = void 0;
exports.isTraversalType = isTraversalType;
exports.isTraversalMatcher = isTraversalMatcher;
exports.isFunctionReferenceCondition = isFunctionReferenceCondition;
exports.isExternalComponentCondition = isExternalComponentCondition;
const TraversalSolvableCharacteristic_1 = require("./TraversalSolvableCharacteristic");
const zod_1 = require("zod");
function isTraversalType(t, type) {
    return typeof t === 'string' ? t === type : t.type === type;
}
function isTraversalMatcher(t) {
    return (typeof t !== 'string' &&
        typeof t === 'object' &&
        !!t &&
        'type' in t &&
        ('endTraversalAtModuleStep' in t || 'endTraversalAtNetStep' in t));
}
exports.TraversalSolvableCharacteristicMatcherSchema = zod_1.default
    .object({
    type: TraversalSolvableCharacteristic_1.TraversalSolvableCharacteristicSchema,
    endTraversalAtModuleStep: zod_1.default.function().output(zod_1.default.boolean()).optional(),
    endTraversalAtNetStep: zod_1.default.function().output(zod_1.default.boolean()).optional(),
})
    .passthrough();
function isFunctionReferenceCondition(condition) {
    return condition.function !== undefined;
}
function isExternalComponentCondition(condition) {
    return (condition.name !== undefined &&
        Array.isArray(condition.components));
}
//# sourceMappingURL=TraversalHelpers.js.map